import { css } from 'lit';

export const style = css`
	* {
		box-sizing: border-box;
	}

	:host {
		display: block;
		min-width: 300px;
	}

	table {
		width: 100%;
		border-collapse: collapse;
	}

	td, th {
		border-right: 1px solid var(--og-border-color);
		border-bottom: 1px solid var(--og-border-color);
		padding: 4px;
		text-align: left;
	}

	tr:last-child td {
		border-bottom: none;
	}

	og-button {
		text-align: center;
	}

	og-icon {
		text-align: center;
	}

	.header {
		display: flex;
		flex-direction: row;
		align-items: center;
		gap: 8px;
	}

	.header .updates-info {
		display: flex;
		align-items: center;
		min-width: 0;
		flex: 1;
		gap: 4px;
	}

	.header .updates-title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		min-width: 0;
		flex: 1;
		width: 1px;
		font-weight: bold;
	}

	.header .updates-icon {
		display: flex;
		flex-shrink: 0;
	}

	.body .updates-buttons {
		display: flex;
		gap: 4px;
	}
`;
